export default "__VITE_ASSET__D30vcG0u__";